import React from "react";
import styled from "styled-components";

const PartnerLogo = ({ name, logo, secondaryLogo, description, url, backgroundColor }) => {
  const handleClick = () => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <StyledPartnerLogo onClick={handleClick}>
    <div style={{ display: "flex",alignSelf: "center"}}>
      <LogoContainer>
        <LogoWrapper backgroundColor={backgroundColor}>
          <PrimaryLogo src={logo} alt={`${name} logo`} $name={name} $hasBackground={!!backgroundColor} />
        </LogoWrapper>
        {name === "BosonQ Psi" && <CompanyName>{name}</CompanyName>}
      </LogoContainer>
      {secondaryLogo && (
        <SecondaryLogo src={secondaryLogo} alt={`${name} secondary logo`} />
      )}
      </div>
      <PartnerDescription>{description}</PartnerDescription>
    </StyledPartnerLogo>
  );
};

const StyledPartnerLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.5;
  width: 100%;

  @media (max-width: 768px) {
    height: 60px;
  }
`;

const LogoWrapper = styled.div`
  background-color: ${props => props.backgroundColor || 'transparent'};
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  width: 100%;
  padding: 10px;

  @media (max-width: 768px) {
    height: 60px;
  }
`;

const PrimaryLogo = styled.img`
  height: ${props => props.$hasBackground ? '50px' : (props.$name === 'RightHear' ? '45px' : '70px')};
  object-fit: contain;

  @media (max-width: 768px) {
    height: ${props => props.$hasBackground ? '40px' : (props.$name === 'RightHear' ? '35px' : '60px')};
  }
`;

const CompanyName = styled.span`
  font-family: Inter, sans-serif;
`;

const SecondaryLogo = styled.img`
  width: 119px;
  max-width: 100%;
  object-fit: contain;
  margin-top: 4px;
`;

const PartnerDescription = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 1.4;
  margin-top: 4px;
  font-family: Inter, sans-serif;
  color: #000;
  max-width: 280px;
  text-align: center;

  @media (max-width: 1400px) {
    max-width: 220px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    max-width: 180px;
  }
`;

export default PartnerLogo;